import { SignatureSizeMtoModule } from './../../signature-size-mto/signature-size-mto.module';
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from "rxjs";
import { ParametrosService } from "src/app/core/services/parametros.service";
import { PermisosModalComponent } from 'src/app/shared/components/permisos-acceso/permisos-modal.component';
import { UsuariosService } from "src/app/core/services/usuarios.service";
import { UsuarioAccesoService } from 'src/app/core/services/usuario_acceso.service';
import { ModelosAccesosService } from 'src/app/core/services/modelo_acceso.service';
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import Swal from "sweetalert2";

// MODELS
import { ModeloMap, ModeloAcceso } from 'src/app/models/ModeloMap.modelo';
import { TABLE_CONFIG } from 'src/app/models/table-config';


interface Item {
    parametro?: string;
    valorParametro?: string;
    etiqueta?: string;
    descripcion?: string;
}
@Component({
    selector: 'app-parametros',
    templateUrl: './accesos.component.html',
    styleUrls: ['./accesos.component.scss'],
})
export class AccesosComponent implements OnInit {
    parametros: any[];
    formParametros: FormGroup;

    currentItems: ModeloMap[keyof ModeloMap][] = [];

    currentPage: number = 1;
    pageSize: number = 10; // Tamaño de página inicial
    totalItems: number = 0;
    spinner: boolean;
    selectModulo: string = '';
    customActions: TableAction[] = [];
    public isEdition: boolean;
    public listModulo: any[];

    @ViewChild('modalAgregarParametro') modalAgregarParametro!: TemplateRef<any>;



    tableHeaders = [];



    constructor(
        private parametrosService: ParametrosService,
        private modeloAccesoService: ModelosAccesosService,
        private usuarioService: UsuarioAccesoService,
        private modalService: NgbModal,
        private fb: FormBuilder
    ) {
        this.formParametros = this.fb.group({
            parametro: new FormControl('', [Validators.required]),
            valorParametro: new FormControl('', [Validators.required]),
            etiqueta: new FormControl('', [Validators.required]),
            descripcion: new FormControl('', [Validators.required])
        });
    }

    async ngOnInit() {
        this.getListModeloAcceso();
        this.customActions = [
            {
                label: 'Gestionar Acceso',
                handler: (item: any) => this.gestionarAcceso(item.id),
                icon: 'fa-solid fa-lock',
                colorClass: 'bg-blue',
                visible: (item: any) => {
                    return !item.publica;
                }
            },
        ];
        // this.getParameters();
    }

    async getAccesoUsuarios<T extends ModeloAcceso>(modelo: T) {
        this.spinner = true;
        let params = new HttpParams();
        params = params.set('modelo', modelo).set('page', this.currentPage).set('limit', this.pageSize).set('pagination', true);
        const config = TABLE_CONFIG[modelo];

        this.tableHeaders = config.headers;

        const result = await lastValueFrom(
            this.usuarioService.getUsuariosAccesos(params)
        );
        const headers: HttpHeaders = result.headers;
        this.spinner = false;
        const items = (result.body ?? []).map(x => x.item) as ModeloMap[T][];
        this.totalItems = Number(headers.get('X-Total-Count'));
        this.currentItems = config.mapper
            ? items.map(config.mapper)
            : items;

    }

    async getListModeloAcceso() {
        const result = await lastValueFrom(this.modeloAccesoService.getListModelos());
        this.listModulo = result.body;
    }

    openModalNewParameter() {
        this.isEdition = false;
        this.formParametros.reset();
        this.openModal(this.modalAgregarParametro);
    }


    onPageChange(newPage: number): void {
        this.currentPage = newPage;
        this.getAccesoUsuarios(this.selectModulo as keyof ModeloMap);
    }

    onPageSizeChange(newSize: number): void {
        this.pageSize = newSize;
        this.currentPage = 1;
        this.getAccesoUsuarios(this.selectModulo as keyof ModeloMap);
    }

    openModal(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }

    async gestionarAcceso(id: any) {
        const modalRef = this.modalService.open(PermisosModalComponent, {
            centered: true,
            size: 'xl',
        });
        modalRef.componentInstance.id = id;
        modalRef.componentInstance.modeloAcceso = this.selectModulo;
    }

    selectionModulo(event: Event) {

        const value = (event.target as HTMLSelectElement).value;

        if (value != '') {
            this.selectModulo = value;
            this.getAccesoUsuarios(value as keyof ModeloMap);
        } else {
            this.selectModulo = '';
            this.currentItems = [];
        }
    }

}